import { render, staticRenderFns } from "./PosPromotionDetail.vue?vue&type=template&id=2144d63b&scoped=true&"
import script from "./PosPromotionDetail.vue?vue&type=script&lang=js&"
export * from "./PosPromotionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144d63b",
  null
  
)

export default component.exports